import { gql } from '@apollo/client'
import { COMIC_COLLECT_FRAGMENT } from './fragments'
/** 获取目录 */
export const GET_COMIC_CATALOGUE = gql`
  query getComicCatalogue($id: Long) {
    squareModule {
      comicCatalogue: comicCollect(id: $id) {
        postList {
          id
          title
          updateTime
          itemSocialInfo {
            viewsCount
          }
          coverImage {
            imageUrl
          }
        }
      }
    }
  }
`
/** 打赏作者 */
export const REWARD_AUTHOR = gql`
  mutation rewardAuthor($postId: Long, $amount: Int) {
    rewardAuthor: squareModule {
      donatePost(input: { postId: $postId, amount: $amount })
    }
  }
`
/** 获取可用永久积分 */
export const GET_AVAILABLE_BABLANCE = gql`
  query getAvailableBalance {
    availableBalance: copyrightUserInfo {
      integralWalletBalance {
        availableBalance
      }
    }
  }
`
/** 漫画合集详情 */
export const GET_COMIC_COLLECTION = gql`
  ${COMIC_COLLECT_FRAGMENT}
  query getComicCollection($id: Long) {
    squareModule {
      comicCollection: comicCollect(id: $id) {
        ...comicCollectFragment
      }
    }
  }
`
/** 编辑更新漫画合集详情信息 */
export const EDIT_COMIC_COLLECTION = gql`
  ${COMIC_COLLECT_FRAGMENT}
  mutation editComicCollect($input: ComicCollectInput) {
    squareModule {
      editComicCollection: updateComicCollect(input: $input) {
        ...comicCollectFragment
      }
    }
  }
`
/** 个人中心漫画列表 */
export const USER_SQUARE_COMIC_PAGE = gql`
  query comicUserSquarePostPage(
    $first: Int
    $offset: Int
    $param: PostUserQueryInput
  ) {
    squareModule {
      userSquarePostPage(
        page: { first: $first, offset: $offset }
        param: $param
      ) {
        pageInfo {
          totalCount
          hasNextPage
        }
        edges {
          node {
            id
            type
            top
            status
            visible
            title
            coverImage {
              imageUrl
              length
              width
            }
            user {
              uid
              nickname
              avatarUrl
            }
            itemSocialInfo {
              viewsCount
              viewsCountStr
            }
            comicCollect {
              type
              updateType
            }
          }
        }
      }
    }
  }
`

/** 前台漫画合集分页 */
export const GET_COMIC_COLLECTION_PAGE = gql`
  query getComicCollectionPage($offset: Int, $first: Int) {
    squareModule {
      comicCollectPage(page: { offset: $offset, first: $first }) {
        edges {
          cursor
          node {
            id
            name
            image
            type
            updateType
          }
        }
        pageInfo {
          hasNextPage
          totalCount
        }
      }
    }
  }
`

/** 前台创建漫画合集 */
export const CREATE_COMIC_COLLECTION = gql`
  mutation postCreateComicCollect($input: ComicCollectInput) {
    squareModule {
      createComicCollect(input: $input) {
        id
      }
    }
  }
`

/** 前台更新漫画合集 */
export const UPDATE_COMIC_COLLECTION = gql`
  mutation updateComicCollect(
    $name: String
    $desc: String
    $image: String
    $type: ComicCollectTypeEnum
    $updateType: ComicCollectUpdateTypeEnum
  ) {
    squareModule {
      updateComicCollect(
        input: {
          name: $name
          desc: $desc
          image: $image
          type: $type
          updateType: $updateType
        }
      ) {
        id
      }
    }
  }
`

/** 漫画详情 */
export const GET_COMIC_POST = gql`
  query getCommicPost($id: Long!, $isEdit: Boolean!) {
    squareModule {
      squarePost(id: $id) {
        id
        title
        content
        type
        publishTime
        updateTime
        commentCount
        top
        visible
        visibleType
        imageList {
          imageUrl
          id
        }
        itemSocialInfo {
          collectsCount
          likesCount
          disLikeCount: putDownCount
          status {
            collected
            liked
            disLiked: putDown
          }
        }
        channel {
          name
          id
          bishopList {
            base {
              uid
            }
          }
        }
        channelEssence
        channelTop
        user {
          uid
          nickname
          avatarUrl
          social {
            followStatus
          }
          muzzleStatus
          memberDetail {
            hold
          }
        }
        comicCollect {
          id
          name
          desc
          image
          type
          updateType
          updateTime
          postList {
            id
          }
        }
        coverImage {
          imageUrl
          id
        }
      }

      postDonationDetailPage(postId: $id, page: { offset: 0, first: 200 })
        @skip(if: $isEdit) {
        edges {
          node {
            user {
              uid
              avatarUrl
            }
          }
        }
        pageInfo {
          hasNextPage
          totalCount
        }
      }
    }
  }
`

/** 个人中心漫画合集列表 */
export const USER_COMIC_COLLECTION_PAGE = gql`
  fragment ComicCollectionEdgeFragment on ComicCollectCollectionEdge {
    node {
      id
      image
      name
      type
      updateType
      user {
        uid
        nickname
        avatarUrl
      }
    }
  }

  query UserComicCollectList(
    $first: Int
    $offset: Int
    $uid: Long
    $isSelf: Boolean = false
  ) {
    squareModule {
      comicCollectOtherPage(
        page: { first: $first, offset: $offset }
        param: { userId: $uid }
      ) @skip(if: $isSelf) {
        edges {
          ...ComicCollectionEdgeFragment
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      comicCollectPage(page: { first: $first, offset: $offset })
        @include(if: $isSelf) {
        edges {
          ...ComicCollectionEdgeFragment
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`
